import { createPortal, useEffect, useState, useRef, useCallback } from 'preact/compat'
import Icon from '@/components/snippets/icon/icon'
import LoaderSpin from '@/components/snippets/loader-spin/loader-spin'

/**
 *  @typedef {import("../types/modal").modalWrapperProp} modalWrapperProp
 *  @typedef {import("../types/modal").modalBackdropProp} modalBackdropProp
 *  @typedef {import("../types/modal").modalBodyProp} modalBodyProp
 *  @typedef {import("../types/modal").pageModalProps} pageModalProps
 */

/**
 *
 * @param {modalBackdropProp} param0
 * @returns
 */
const ModalBackDrop = ({ isOpen, handleToggle }) => {
  const inView = isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'

  return (
    <div
      onClick={isOpen ? handleToggle : undefined}
      className={`fixed inset-0 z-[49] h-screen w-screen cursor-pointer bg-black/40 transition-all duration-300 ${inView}`}
    ></div>
  )
}

/**
 *
 * @param {modalWrapperProp} param0
 * @returns
 */
export const ModalBodyWrapper = ({ children, config }) => {
  return (
    <form onSubmit={config?.submitCallback} className={'flex flex-1 flex-col overflow-y-hidden'}>
      <div className={'flex-1 overflow-y-auto'}>
        <div className={'flex flex-col p-4'}>{children}</div>
      </div>
      <div className={'flex flex-row gap-4 bg-neutrals-base p-4'}>
        {config?.buttons ? (
          <>{config.buttons}</>
        ) : (
          <>
            <button type="button" className={'btn btn-md btn-outline-black'} onClick={config?.handleToggle}>
              Cancel
            </button>
            <button
              className={'btn btn-md btn-solid-black relative flex-grow overflow-hidden'}
              type="submit"
              disabled={config?.disabled || config?.isLoading}
            >
              {config?.isLoading ? (
                <LoaderSpin wrapperClass="bg-black" />
              ) : (
                config.submitButtonText || (
                  <>
                    {config?.id ? 'Edit' : 'Add'} {config?.title}
                  </>
                )
              )}
            </button>
          </>
        )}
      </div>
    </form>
  )
}

/**
 *
 * @param {modalBodyProp} param0
 * @returns
 */
const ModalBody = ({ isOpen, title, handleToggle, children }) => {
  return (
    <div
      className={`fixed bottom-0 right-0 top-0 z-50 flex h-full w-full items-center justify-center transition-all duration-300 ease-in-out md:w-140 ${
        isOpen ? 'translate-x-0 opacity-100' : 'translate-x-96 opacity-0 pointer-events-none'
      }`}
    >
      <div className={'flex h-full w-full flex-col overflow-hidden rounded-l-md bg-primary-white'}>
        <div className={'flex w-full flex-row items-center justify-between border-b p-4'}>
          <h4 className={'h4'}>{title}</h4>
          <button type="button" className={'-m-4 p-4'} onClick={handleToggle}>
            <Icon id="close" />
          </button>
        </div>
        {children}
      </div>
    </div>
  )
}

/**
 *
 * @param {pageModalProps} param0
 * @returns
 */
export const PageModal = ({ props, children }) => {
  return (
    <>
      {createPortal(
        <>
          <ModalBody title={props.modalTitle} isOpen={props.isActive} handleToggle={props.handleToggle}>
            {props.modal}
          </ModalBody>
          <ModalBackDrop isOpen={props.isActive} handleToggle={props.handleToggle} />
        </>,
        document.body
      )}
      {children}
    </>
  )
}
